import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';

const ValidationResults = ({ validation, showAllWarnings, onToggleWarnings }) => {
    if (!validation) return null;

    const errors = validation.errors || [];
    const warnings = validation.warnings || [];
    const visibleWarnings = showAllWarnings ? warnings : warnings.slice(0, 3);

    return (
        <Alert severity={validation.valid ? 'success' : 'error'} variant="outlined">
            <Typography variant="body2" fontWeight={700}>
                {validation.valid
                    ? 'Draft validation passed.'
                    : `Draft validation failed${errors.length ? `: ${errors.slice(0, 3).join(' ')}` : '.'}`}
            </Typography>
            {errors.length > 3 && (
                <Typography variant="caption" display="block" color="text.secondary">
                    {errors.length - 3} more validation errors are available after fixing the first set.
                </Typography>
            )}
            {warnings.length > 0 && (
                <Box mt={0.75}>
                    <Typography variant="caption" color="text.secondary" display="block">Warnings</Typography>
                    {visibleWarnings.map((warning) => (
                        <Typography key={warning} variant="body2">{warning}</Typography>
                    ))}
                    {warnings.length > 3 && (
                        <Button size="small" onClick={onToggleWarnings} sx={{ mt: 0.5, px: 0 }}>
                            {showAllWarnings ? 'Show fewer warnings' : `Show all warnings (${warnings.length})`}
                        </Button>
                    )}
                </Box>
            )}
        </Alert>
    );
};

export default ValidationResults;
